<template>
  <div>
    <!-- Saving Message -->
    <transition name="expand">
      <div class="App-done--block" v-show="isSubmitting">
        <i class="material-icons App-icon-top App-done-icon">cloud_upload</i>
        <h1 class="App-saving--header headline">Saving...</h1>
        <div class="mdl-spinner mdl-js-spinner is-active"></div>
        <p class="App-saving--flavour">Just One Second</p>
      </div>
    </transition>

    <!-- Success Message -->
    <transition name="expand">
      <div class="App-done--block" v-show="isSuccess">
        <i class="material-icons App-icon-top App-done-icon">
          assignment_turned_in
        </i>
        <h1 class="App-done--header headline">Your Form Has Been Received!</h1>

        <div v-if="preventDownloading">
          <p class="App-done--message">
            A confirmation email has been sent to you.
          </p>
          <p class="App-done--message">
            Please contact us at
            <a href="mailto:support@getquorum.com">support@getquorum.com</a>
            if you have not received it within 24 hours, check your spam or junk
            mail folder just in case.
          </p>
        </div>

        <div v-else>
          <p class="App-done--message">
            A copy has been emailed to you for your records.
          </p>
          <p class="App-done--message">
            Please contact us at
            <a href="mailto:support@getquorum.com">support@getquorum.com</a>
            if you have not received it within 24 hours, check your spam or junk
            mail folder just in case.
          </p>

          <p class="App-done--message">
            You may also download a copy of your form using the button below.
          </p>
          <div v-if="isSuccess">
            <a
              target="_blank"
              :href="proxyDownloadLink"
              class="mdl-button mdl-js-button mdl-button--primary mdl-button--raised"
            >
              <i class="material-icons">file_download</i>
              Download a Copy
            </a>
          </div>
        </div>

        <div v-if="collectRtvBallots && !unitLastBallotVotedAt">
          <h6>Submit your advance ballot?</h6>
          <p>
            Our records indicate that you are eligible to submit your advance
            ballot before the meeting as well. Click the button below to submit
            your ballot.
          </p>
          <button
            @click="openRtvBallot"
            class="mdl-button mdl-js-button mdl-button--primary mdl-button--raised"
          >
            submit ballot
          </button>
        </div>

        <div v-if="showStartAgainLink">
          <h6>Want to change your answers?</h6>
          <p>
            No problem, you can resubmit your vote at any time until voting is
            closed.
          </p>
          <button
            @click="startNewProxy"
            class="mdl-button mdl-js-button mdl-button--accent mdl-button--raised"
          >
            Start Again
          </button>
        </div>
      </div>
    </transition>

    <!-- Saving Message -->
    <transition name="expand">
      <div class="App-done--block" v-show="isError">
        <i class="material-icons App-icon-top App-done-icon">error</i>
        <h1 class="App-done--header headline">
          Oops, there was an error saving your form.
        </h1>
        <p class="App-done--message">Please try submitting again.</p>
        <p class="App-done--message">
          If you continue to have errors, please contact us at
          <a href="mailto:support@getquorum.com">support@getquorum.com</a>
          .
        </p>

        <button
          @click="resubmit"
          class="mdl-button mdl-js-button mdl-button--primary mdl-button--raised"
        >
          Submit again
        </button>

        <div class="App-done--block__error">
          {{ submissionResponse.status }} - {{ submissionResponse.data }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash';
import {mapActions, mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters({
      submissionResponse: 'done/submissionResponse',
      trackingCode: 'trackingCode',
      shortCode: 'shortCode',
      token: 'token',
      displayOptions: 'displayOptions',
      meetingOptions: 'meetingOptions',
      meeting: 'meeting/meeting'
    }),
    isSubmitting() {
      return this.submissionResponse.status === 0;
    },
    isSuccess() {
      return this.submissionResponse.status === 200;
    },
    isError() {
      return (
        this.submissionResponse.status !== 200 &&
        this.submissionResponse.status !== 0
      );
    },
    proxyDownloadLink() {
      return _.has(this.submissionResponse, 'data.signedUrl')
        ? this.submissionResponse.data.signedUrl
        : '';
    },
    showStartAgainLink() {
      return _.get(this.displayOptions, 'done.show_start_again', true);
    },
    preventDownloading() {
      return _.get(
        this.meetingOptions,
        'disable_proxy_submission_downloads',
        false
      );
    },
    collectRtvBallots() {
      return _.get(this.meetingOptions, 'collect_rtv_ballots', false);
    },
    unitLastBallotVotedAt() {
      return _.get(this.meeting, 'voter.lastUnitBallotVotedAt', null);
    }
  },
  methods: {
    ...mapActions('done', ['saveSubmission']),
    resubmit() {
      // Track it
      this.saveSubmission();
    },
    startNewProxy() {
      const location = `/?code=${this.trackingCode}&token=${this.token}`;
      window.location.href = location;
    },
    openRtvBallot() {
      let baseurl =
        process.env.NODE_ENV === 'production'
          ? 'https://vote.getquorum.com'
          : 'http://localhost:8085';

      let url = `${baseurl}/${this.shortCode}/vote?token=${this.token}`;

      window.open(url, '_blank');
    }
  },
  created() {
    this.saveSubmission();
  },
  mounted() {
    componentHandler.upgradeAllRegistered();
  }
};
</script>

<style scoped>
.App-saving--header {
  padding-bottom: 2rem;
}
.App-saving--flavour {
  padding-top: 3rem;
}
.App-done--block__error {
  margin-top: 5rem;
  font-size: 10px;
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/components/Done.vue